import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const visitors = {
        isLoading: false,
        init() {
            $(document).on('click', '[data-track="yes"]', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let pageId = $(this).data('track-page-id');
			let module = $(this).data('track-module');
			let moduleId = $(this).data('track-module-id');
			let action = $(this).data('track-action');
			let itemId = $(this).data('track-item-id');

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;

            var formdata = new FormData();
            formdata.append("page_id", pageId);
            formdata.append("module", module);
            formdata.append("module_id", moduleId);
            formdata.append("item_id", itemId);
            formdata.append("action", action);
            formdata.append("_token", $("meta[name='csrf-token']").attr("content"));
			$.ajax({
	            type: "POST",
	            url: baseURL + '/track/visit',
	            data: formdata,
                processData: false,
                contentType: false,
	            success: function(response) {
					_this.isLoading = false;

	            },
                error(error) {
                    _this.isLoading = false;
                },
	        });
		}
    };

    //if ($('.form-contact-home').length) {
        visitors.init();
    //}
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/visitors.js